// src/pages/micuenta/Suscripciones.jsx
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft, FaBell } from "react-icons/fa";
import "./suscripciones.css";

function Subscription() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="account-container">
        <div className="account-card">
          <h2 className="account-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="account-container">
      <div className="account-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        {/* Encabezado de la sección de Suscripción */}
        <h2 className="account-section-title">
          <FaBell className="section-icon" /> Suscripción
        </h2>

        {/* Tarjeta de suscripción */}
        <div className="subscription-plan-card">
          <h3>PLAN PREMIUM</h3>
          <ul>
            <li>Todo lo del plan básico</li>
            <li>Acceso prioritario a empleos destacados</li>
            <li>Guardar empleos como favoritos</li>
            <li>Recursos exclusivos educativos, de emprendimiento y migratorios</li>
          </ul>
          <div className="subscription-actions">
            <button className="subscription-btn">Cambiar Plan</button>
            <button className="subscription-btn">Cancelar Plan</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Subscription;